/* eslint-disable */
import $ from 'jquery';
import { DataLayer_form } from './DataLayer_form';
let self;
let page_path;
let datalayer_form_attr = {};
let trigger_datalayer_form = false;
let first_interaction = [];
let observer = null;
let user_email;

export class DataLayer_events_form {
  constructor() {
    self = this;
    page_path = window.location.href; // Get the current url
    // bind events
    $(window).on('load', () => self.onLoad());
    $(document).on('input','.lyceo-component.formulier form input',e => self.contactStep1(e));

    // bind Gravity forms submission
    document.addEventListener('gform/theme/scripts_loaded', () => {
      gform.utils.addAsyncFilter('gform/submission/pre_submission', async (data) => {
        const formId = data.form.dataset.formid;
        const formElement = $('#gform_' + formId);
        self.storeUserEmail(formElement, '.ginput_container_email input');
        self.contactStep2();
        return data;
      });
    });
  }

  onLoad(){
    datalayer_form_attr.page_path = page_path;
    // Check if the page is full form or thank you page
    if ( page_path.indexOf( '/contact/' ) >= 0 ) {
      self.contactStep0();
    }
    if ( page_path.indexOf( '/contact-bedankt' ) >= 0 ) {
      self.contactStep2();
    }
    // Push a new datalayer when the page is a visible form
    if ( trigger_datalayer_form ) {
      trigger_datalayer_form = false;
      new DataLayer_form( datalayer_form_attr );
    }
  }

  contactStep0() {
    self.isContactForm();
    datalayer_form_attr.step_name = 'visible';
    datalayer_form_attr.step = '0';
    new DataLayer_form( datalayer_form_attr );
    first_interaction = first_interaction.filter(function(item) {
      return item !== 'contact';
    });
  }

  contactStep1(e, form) {
    if ( !first_interaction.includes('contact') ) {
      self.isContactForm(form);
      datalayer_form_attr.step_name = 'first_interaction';
      datalayer_form_attr.step = '1';
      new DataLayer_form( datalayer_form_attr );
    }
  first_interaction.push('contact');
  }

  contactStep2() {
    observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        $(mutation.addedNodes).each((_, node) => {
          if ($(node).is('.gform_confirmation_message') || $(node).find('.gform_confirmation_message').length) {
            // Disconnect observer when the message is detected
            observer.disconnect();
            self.isContactForm();
            datalayer_form_attr.user_email = window.localStorage.getItem('user_email_key');
            datalayer_form_attr.step_name = 'complete';
            datalayer_form_attr.step = '2';
            new DataLayer_form(datalayer_form_attr);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  // Define the standard variables for the contact form datalayer
  isContactForm() {
    datalayer_form_attr.form_type = 'full_page';
    datalayer_form_attr.form_variant = 'contact_info';
    datalayer_form_attr.event = 'general_contact_form';
    datalayer_form_attr.form_id = '#gform_1';
    datalayer_form_attr.form_name = 'Contactformulier';
  }

  storeUserEmail(e, emailField) {
    const target = e instanceof jQuery ? e : $(e.currentTarget);
    user_email = target.find(emailField).val();
    window.localStorage.setItem('user_email_key', user_email);
  }

}
